export function getLanguage(language) {
    if (!language) {
        return 'en'
    }
    let result = language
    if (language.indexOf('_') !== -1) {
        result = language.split('_')[1]
    }
    if (!result) {
        return 'en'
    }
    return result
}